import {
  FETCHED_GROUPS,
  START_FETCHING_GROUPS
} from '../actionTypes';

import { GroupType } from '../../types/AppTypes';

interface InitialState {
  groups:GroupType[];
  loading: boolean;
  error: any;
  message: any;
  podcast: any;
  tablePageSize: number;
  currentPage: number;
}

const initialState: InitialState = {
  groups: [],
  loading: false,
  error: null,
  message: null,
  podcast: null,
  tablePageSize: 10,
  currentPage: 1,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_GROUPS:
      return {
        ...state,
        groups: [],
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_GROUPS: {
      const { groups, error, message } = action.payload;
      return {
        ...state,
        groups,
        error,
        message,
        loading: false,
      };
    }
    default:
      return state;
  }
}
